/**
 * Shared viewport breakpoints in pixels for app-level responsive layouts.
 */
export const breakpoints = {
  xs: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1536,
} as const;
